import { IClientFieldsVisibility } from '@app/core/model/env-config.model';

export function isClientFieldVisible(
  clientFieldsVisibility: IClientFieldsVisibility,
  fieldName: keyof IClientFieldsVisibility
): boolean {
  return clientFieldsVisibility[fieldName] ?? true;
}
